export const LOAD_STATE = 'LOAD_STATE';
export const SET_LOADING = 'SET_LOADING';
export const SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING';
export const SET_LOGO_PARAMS = 'SET_LOGO_PARAMS';
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
export const UPDATE_ORGANIZATION_LOGO = 'UPDATE_ORGANIZATION_LOGO';
export const UPDATE_INVOICE_LOGO = 'UPDATE_INVOICE_LOGO';
